import React, { FunctionComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface RevenueGraphProps {
  weeklySales: any;
  viewRolePermission: boolean;
}
export const WeeklySalesReport: FunctionComponent<RevenueGraphProps> = ({
  weeklySales,
  viewRolePermission
}) => {

  // const changedArray: any = []
  // weeklySales.map((i: any) => {
  //   const record = {
  //     days: i.days === "Monday" ? "Mon" :
  //       i.days === "Tuesday" ? "Tue" :
  //         i.days === "Wednesday" ? "Wed" :
  //           i.days === "Thursday" ? "Thur" :
  //             i.days === "Friday" ? "Fri" :
  //               i.days === "Saturday" ? "Sat" : "Sun",
  //     edo_date: i.edo_date,
  //     gross: i.gross,
  //     net: i.net
  //   }
  //   changedArray.push(record);
  // });

  const grossArray=weeklySales.map((val:any) => val.gross)
  const netArray=weeklySales.map((val:any) => val.net)
  const max = Math.max.apply(null, grossArray.concat(netArray));


  if (weeklySales.length === 0) {
    return <h2>No data to show report!</h2>
  } else {
    return (
      <ResponsiveContainer width={550} height={400}>
        <LineChart
          data={weeklySales}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="days" />
          <YAxis type="number" domain={[0, max+10]} />
          <Tooltip />
          <Legend
            margin={{ top: 15, bottom: 15 }}
          />
          <Line type="monotone" dataKey="gross" stroke="red" activeDot={{ r: 8 }} />
          <Line type="monotone" dataKey="net" stroke="#2a3e52" />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}


